import { render, staticRenderFns } from "./DisclaimerDialog.vue?vue&type=template&id=6bd037f4"
import script from "./DisclaimerDialog.vue?vue&type=script&lang=ts"
export * from "./DisclaimerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports